import { render, staticRenderFns } from "./MediaGallery.vue?vue&type=template&id=2ea985f0&"
import script from "./MediaGallery.vue?vue&type=script&lang=ts&"
export * from "./MediaGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports